<template>
  <v-container fluid grid-list-md>
    <v-layout column wrap>
      <v-flex xs12>
        <filters-bar 
          title="Canales"
          title-class="headline font-weight-thin" 
          :filters="filters"
          :has-company-load="true"
          @search="search">
        </filters-bar>
      </v-flex>
      <v-flex xs12>
        <v-layout>
          <v-flex md3>
            <channel :channelsFilter="channelsFilter" :channel="filters.channel" @setChannel="setChannel"/>
          </v-flex>
          <v-flex md9 pl-3>
            <pie-line 
              :quantity="channelsFilter"
              :dateCustomer="dateCustomer"
              :dateNotification="dateNotification"
              :dateMCustomer="dateMCustomer"
              :dateMNotification="dateMNotification"
              :step="step" 
              @update-step="$emit('update-step', $event)" 
              :filters="filters"/>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import FiltersBar from '@/components/global/FiltersBar';
import Channel from './Channel';
import PieLine from './PieLine';

export default {
  props: {
    step: {
      type: Number,
      default: 0,
    },
    dateCustomer: {
      type: [String, undefined],
      default: 'No posee',
    },
    dateNotification: {
      type: [String, undefined],
      default: 'No posee',
    },
    dateMCustomer: {
      type: [String, undefined],
      default: 'No posee',
    },
    dateMNotification: {
      type: [String, undefined],
      default: 'No posee',
    },
  },
  components: {
    FiltersBar,
    Channel,
    PieLine,
  },
  mounted() {
    this.searchChannels();
  },
  data() {
    return {
      channel: {},
      filters: {
        channel: 4,
        company_load: 0,
        total_load: 0,
        dateType: 'date',
        date: moment().format('YYYY-MM-DD'),
      },
      oldDate: moment().format('YYYY-MM-DD'),
      cancelToken: this.axios.CancelToken.source(),
      channelsFilter: [
        {
          name: 'BOT',
          customer: 0,
          id: 4,
          schedules: 0,
          icon: 'fas fa-robot',
        },
        {
          name: 'SMS',
          customer: 0,
          id: 2,
          schedules: 0,
          icon: 'fas fa-comments',
        },
        {
          name: 'Email',
          customer: 0,
          id: 1,
          schedules: 0,
          icon: 'fas fa-envelope',
        },
        {
          name: 'IVR',
          customer: 0,
          id: 3,
          schedules: 0,
          icon: 'fas fa-phone fa-rotate-90',
        },
        {
          name: 'Callcenter individual',
          customer: 0,
          id: 6,
          schedules: 0,
          icon: 'fas fa-user',
        },
        {
          name: 'Callcenter discador',
          customer: 0,
          id: 5,
          schedules: 0,
          icon: 'fas fa-users',
        },
        {
          name: 'Whatsapp',
          customer: 0,
          id: 7,
          schedules: 0,
          icon: 'fab fa-whatsapp',
        },
        {
          name: 'Visitas',
          customer: 0,
          id: 10,
          schedules: 0,
          icon: 'fas fa-user',
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      'companyLoad',
    ]),
  },
  methods: {
    cancelRequest() {
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
    },
    searchChannels() {
      if (this.filters.date !== this.oldDate) {
        this.filters.company_load = 0;
      }
      this.cancelRequest();
      this.axios.get('channels/report', {
        cancelToken: this.cancelToken.token,
        params: {
          ...this.filters,
        },
      }).then((res) => {
        this.oldDate = this.filters.date;
        this.filters.company_load = res.data.companyLoadId;
        const customers = res.data.customer;
        const notifications = res.data.notification;
        for (let i = 0; i < this.channelsFilter.length; i += 1) {
          if (customers) {
            const temp = customers.find(x => x.channel_id === this.channelsFilter[i].id);
            this.channelsFilter[i].customer = (temp || {}).total || 0;
          }
          if (notifications) {
            const temp = notifications.find(x => x.channel_id === this.channelsFilter[i].id);
            this.channelsFilter[i].schedules = (temp || {}).total || 0;
          }
          if (this.filters.channel === this.channelsFilter[i].id) {
            this.channel = this.channelsFilter[i];
          }
        }
      }).catch(() => {});
    },
    setChannel(channel) {
      this.filters.channel = channel;
      this.searchChannels();
    },
    search(filters) {
      this.filters = {
        ...this.filters,
        ...filters,
      };
      this.filters.company_load = this.filters.company_load;
      this.searchChannels();
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.searchChannels();
      },
    },
    'filters.date': {
      handler(val) {
        if (val !== moment().format('YYYY-MM')) {
          this.filters.total_load = 1;
        } else {
          this.filters.total_load = 0;
        }
      },
    },
    companyLoad(val) {
      if (!this.filters.company_load && val.length > 0) {
        this.filters.company_load = (val.find(x => x.priority === 1) || {}).id || 0;
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/panelV2/Channels/Index.vue